'use client'

import { FC } from 'react'
import Bottom from './Bottom'
import { Pages, IFooterPage } from './Pages/Pages'
import SignUp from './SignUp'
import findIndex from 'lodash/findIndex'
import { TheWrap } from '@components/icons'
import {
  FooterBanner,
  IFooterBanner,
} from '@components/common/Footer/FooterBanner'
import { GenericContentBlock } from 'types/contentful/genericContentBlock'
import {
  IImage,
  mapContentfulImageAsset,
} from '@utils/contentful/contentfulImage'
import { THubspotFormSpecification } from '@utils/form/hubspot/schema'
import { TConsentOptions } from '@utils/form/schema'
import { usePathname } from 'next/navigation'

const PATH_WITH_NO_FOOTER = ['/upload/', '/quote/', 'test-page-app-router']

const hydrateFooterColumnsWithExtraInfo = (
  footerColumns: IFooterPage[] = []
) => {
  const indexOfTheWrap = findIndex(footerColumns, (footerColumn) =>
    footerColumn?.text?.toLowerCase()?.includes('inspo')
  )

  if (indexOfTheWrap >= 0 && footerColumns?.[indexOfTheWrap]?.pages?.[0]) {
    footerColumns[indexOfTheWrap].pages![0].Component = TheWrap
  }

  return footerColumns
}
function FooterClient({
  className,
  children,
  footerColumns,
  bannerContent,
  badgeImage,
  footerSignupForm,
}: {
  className?: string
  children?: any
  footerColumns: IFooterPage[]
  bannerContent: GenericContentBlock
  badgeImage: IImage
  footerSignupForm: {
    hubspotId: string
    consentSpec: TConsentOptions
    formSpec: THubspotFormSpecification
  }
}) {
  const pathname = usePathname()
  // Not ideal, but placing this check here since NextJS 14 can't access pathname/headers in layouts:
  // https://nextjs.org/docs/app/api-reference/file-conventions/layout#pathname
  // https://nextjs.org/docs/app/api-reference/file-conventions/layout#request-object
  const hideFooter = PATH_WITH_NO_FOOTER.some((path) => pathname.includes(path))

  if (hideFooter) {
    return null
  }

  const footerBannerContentProps: IFooterBanner = {
    title: bannerContent?.h1,
    leftIamge: mapContentfulImageAsset(bannerContent?.primaryImages[0]),
    link: bannerContent?.ctaLink,
    linkLabel: bannerContent?.ctaLabel,
  }

  return (
    <footer id="join-us" className={className}>
      <div className="bg-white font-mori pt-28">
        <div className="relative flex flex-col md:px-16 gap-[16px] content-container">
          <div className="w-full">
            {footerColumns && footerColumns.length > 0 && (
              <Pages
                pages={hydrateFooterColumnsWithExtraInfo(footerColumns)}
                footerBannerContent={{
                  ...footerBannerContentProps,
                  className: 'xxs:hidden lg:flex',
                }}
              />
            )}
          </div>

          <FooterBanner
            className="mt-0 md:mx-0 xl:hidden"
            {...footerBannerContentProps}
          />

          <SignUp signupForm={footerSignupForm} />

          <Bottom />
        </div>
      </div>
    </footer>
  )
}

export default FooterClient
